export default __webpack_public_path__ + "static/Digital_footprint-ed3895f2c57a9f3d31c94899efc5c913.webp";